<div class="vendor-data pt-2">
    <header class="mb-2 container">
        <div>
            <span class="brand"
                ><img src="assets/images/jsw-logo.png" alt="jsw-logo"
            /></span>
        </div>
    </header>

    <main class="container justify-content-center py-2">
        <div class="row">
            <div class="col-md-12" *ngIf="!isError">
                <h2 class="text-center mb-4 text-white">Confirm Details</h2>
                <div class="info-pane mb-2">
                    <p>The Vendor Master Data is currently not editable.</p>
                    <p>
                        If you find any discrepancies in the data below, please
                        reach out to the Location buyer for necessary updation.
                    </p>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="data-pane mb-2">
                            <h5 class="mb-2">Vendor Personal Details</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="data-tag mb-4">
                                        <h6>Vendor Name</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_name !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_name }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_name === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Country</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_country !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_country }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_country === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="data-tag mb-4">
                                        <h6>Vendor Code</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_code !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_code }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_code === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="data-pane mb-2">
                            <h5 class="mb-2">Vendor Contact Details</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="data-tag mb-4">
                                        <h6>Postal Code</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_postal_code !==
                                                ''
                                            "
                                        >
                                            {{ vendorData.vendor_postal_code }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_postal_code ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Region</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_region !==
                                                null
                                            "
                                        >
                                            {{ vendorData.vendor_region }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_region ===
                                                    null ||
                                                vendorData.vendor_region === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>City</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_city !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_city }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_city === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="data-tag mb-4">
                                        <h6>Email Address</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_email !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_email }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_email === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Contact Number</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_mobile !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_mobile }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_mobile === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Address</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_address !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_address }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_address === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="data-pane mb-2">
                            <h5 class="mb-2">Vendor Bank Details</h5>
                            <table
                                aria-describedby="bank-details"
                                class="table mb-0 toggle-arrow-tiny tablet breakpoint bank-details"
                            >
                                <thead>
                                    <tr>
                                        <th>Bank Name</th>

                                        <th>Bank Country</th>

                                        <th>Account No.</th>
                                        <th>Account Holder</th>
                                        <th>IFSC Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        class="footable-even footable-detail-show"
                                        *ngFor="
                                            let bank of vendorData.bank_details
                                        "
                                    >
                                        <td *ngIf="bank.bank_name !== ''">
                                            {{ bank.bank_name }}
                                        </td>
                                        <td *ngIf="bank.bank_name === ''">
                                            NA
                                        </td>

                                        <td *ngIf="bank.bank_county !== ''">
                                            {{ bank.bank_county }}
                                        </td>
                                        <td *ngIf="bank.bank_county === ''">
                                            NA
                                        </td>
                                        <td *ngIf="bank.bank_account_no !== ''">
                                            {{ bank.bank_account_no }}
                                        </td>
                                        <td *ngIf="bank.bank_account_no === ''">
                                            NA
                                        </td>
                                        <td
                                            *ngIf="
                                                bank.bank_account_holder !== ''
                                            "
                                        >
                                            {{ bank.bank_account_holder }}
                                        </td>
                                        <td
                                            *ngIf="
                                                bank.bank_account_holder === ''
                                            "
                                        >
                                            NA
                                        </td>
                                        <td *ngIf="bank.bank_ifsc_code !== ''">
                                            {{ bank.bank_ifsc_code }}
                                        </td>
                                        <td *ngIf="bank.bank_ifsc_code === ''">
                                            NA
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="data-pane mb-5 p5-2">
                            <h5 class="mb-2">Vendor Statutory Details</h5>
                            <div class="row">
                                <div class="col-md-6 py">
                                    <div class="data-tag mb-4">
                                        <h6>PAN Number</h6>
                                        <p *ngIf="vendorData.vendor_pan !== ''">
                                            {{ vendorData.vendor_pan }}
                                        </p>
                                        <p *ngIf="vendorData.vendor_pan === ''">
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Tax Registration Number</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstin !== ''
                                            "
                                        >
                                            {{ vendorData.vendor_gstin }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstin === ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>Tax Registration Status</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstin_status !==
                                                ''
                                            "
                                        >
                                            {{ vendorData.vendor_gstin_status }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstin_status ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>IRN E-invoice status</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_einvoice_status !==
                                                ''
                                            "
                                        >
                                            {{
                                                vendorData.vendor_einvoice_status
                                            }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_einvoice_status ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>

                                    <div class="data-tag mb-4">
                                        <h6>Tax Return Filing Status</h6>
                                        <p *ngIf="statusExist">
                                            {{ vendorData.tax_return_status }}
                                        </p>
                                        <p *ngIf="!statusExist">
                                            Not available
                                        </p>
                                    </div>

                                    <div class="data-tag mb-4">
                                        <h6>Tax Return Filing Frequency</h6>
                                        <p *ngIf="freqExist">
                                            {{
                                                vendorData.tax_return_frequency
                                            }}
                                        </p>
                                        <p *ngIf="!freqExist">Not available</p>
                                    </div>

                                    <div class="data-tag mb-4">
                                        <h6>Last Tax Filing Date</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstr_filing_date !==
                                                ''
                                            "
                                        >
                                            {{
                                                vendorData.vendor_gstr_filing_date
                                            }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_gstr_filing_date ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>

                                    <!-- <div class="data-tag mb-4">
                                <h6>Partner Function</h6>
                                <p>{{ vendorData.vendor_partner_function }}</p>
                                
                            </div> -->
                                </div>
                                <div class="col-md-6">
                                    <div class="data-tag mb-4">
                                        <h6>Industry</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_industry !==
                                                null
                                            "
                                        >
                                            {{ vendorData.vendor_industry }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_industry ===
                                                null
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>URN Number</h6>
                                        <p *ngIf="vendorData.vendor_unr !== ''">
                                            {{ vendorData.vendor_unr }}
                                        </p>
                                        <p *ngIf="vendorData.vendor_unr === ''">
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>MSME Validity Start Date</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_msme_start_date !==
                                                ''
                                            "
                                        >
                                            {{
                                                vendorData.vendor_msme_start_date
                                            }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_msme_start_date ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div class="data-tag mb-4">
                                        <h6>MSME Validity End Date</h6>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_msme_end_date !==
                                                ''
                                            "
                                        >
                                            {{
                                                vendorData.vendor_msme_end_date
                                            }}
                                        </p>
                                        <p
                                            *ngIf="
                                                vendorData.vendor_msme_end_date ===
                                                ''
                                            "
                                        >
                                            Not available
                                        </p>
                                    </div>
                                    <div
                                        class="td-codes"
                                        *ngFor="
                                            let td_code of vendorData.tds_codes;
                                            let lastItem = last
                                        "
                                    >
                                        <div
                                            class="data-tag mb-4"
                                            *ngIf="
                                                td_code.tds_code_section !== ''
                                            "
                                        >
                                            <h6>
                                                TDS Codes Applicable - Section
                                            </h6>
                                            <p>
                                                {{ td_code.tds_code_section }}
                                            </p>
                                        </div>
                                        <div
                                            class="data-tag mb-4"
                                            *ngIf="
                                                td_code.tds_code_tax_code !== ''
                                            "
                                        >
                                            <h6>
                                                TDS Codes Applicable - Tax Code
                                            </h6>
                                            <p>
                                                {{ td_code.tds_code_tax_code }}
                                            </p>
                                        </div>
                                        <hr *ngIf="!lastItem" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center mb-4">
                    <button
                        (click)="confirmDetails()"
                        type="submit"
                        class="btn btn-primary short center"
                    >
                        Proceed
                    </button>
                </div>
            </div>
            <div class="col-md-8 offset-md-2" *ngIf="isError">
                <h2 class="text-center mb-4 text-white">Confirm Details</h2>
                <div class="info-pane mb-5">
                    <p>
                        The Vendor Master Data is currently not editable. To
                        make changes, kindly contact the JSW support team. Thank
                        you.
                    </p>
                </div>

                <div class="data-pane empty text-center mb-4">
                    Sorry unable to load your data please try again or contact
                    JSW support team
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <span class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></span>
        </p>
    </footer>
</div>
